export default __webpack_public_path__ + "static/winter-holidays_6-dcc04a8655dd79b81105ba818d7e232d.png";